const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCat2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 2084 2084",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.937,1603.547c14.02,-121.216 425.704,-173.328 918.763,-116.299c493.059,57.029 881.978,201.741 867.958,322.957c-14.02,121.216 -425.704,173.328 -918.763,116.299c-493.059,-57.029 -881.978,-201.741 -867.958,-322.957Z",
    style: {
      fill: "#f3d077",
      fillOpacity: 0.36
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1570.196,1390.813c42.354,105.096 142.433,195.571 233.725,274.767c126.275,109.546 54.117,133.075 31.371,116.604c-18.571,24.162 -41.596,20.254 -65.1,13.333c0,0 -17.254,21.963 -54.117,4.704c-36.862,-17.254 -70.587,-58.037 -70.587,-58.037l-284.704,-143.358c0,0 -88.629,-65.267 -85.492,-69.975c3.137,-4.704 165.492,-145.096 165.492,-145.096l129.413,7.058Z",
    style: {
      fill: "#f3d077",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1744.783,1806.783l0,19.325",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#933642",
      strokeWidth: "8.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1811.775,1799.092l0,21.133",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#933642",
      strokeWidth: "8.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1864.779,1783.904l0,15.188",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#933642",
      strokeWidth: "8.33px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1835.296,1782.183c17.058,12.354 73.083,-6.763 41.175,-58.825c-10.638,-17.354 -40.979,-30.396 -72.546,-57.779c-25.558,-22.171 -51.804,-45.229 -77.283,-69.246c-42.013,0.079 -27.817,65.7 -27.817,65.7c0,0 -43.921,-38.079 -49.021,-32.887c-5.1,5.192 16.862,39.308 16.862,39.308c0,0 -41.963,-31.767 -69.021,-28.233c-22.525,2.938 -27.062,33.612 -17.792,68.912l65.633,33.05c0,0 33.725,40.783 70.587,58.037c36.862,17.254 54.117,-4.704 54.117,-4.704c23.508,6.921 46.533,10.833 65.104,-13.333Z",
    style: {
      fill: "#e5952a",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1629.138,1490.871c-19.271,-25.146 -36.079,-51.221 -49.233,-78.292l-177.3,4.254c-48.2,41.817 -125.158,108.792 -127.308,112.017c-3.138,4.704 85.492,69.975 85.492,69.975l284.704,143.358c0,0 33.725,40.783 70.587,58.037c31.333,14.667 48.45,1.033 52.896,-3.396c-42.458,-71.504 -145.638,-210.196 -139.838,-305.954Z",
    style: {
      fill: "#f3d077",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1770.196,1795.517c14.117,-20.392 8.629,-47.058 8.629,-47.058",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#f3d077",
      strokeWidth: "8.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1835.296,1782.183c10.196,-25.096 -6.275,-40 -14.9,-45.492",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#f3d077",
      strokeWidth: "8.33px"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1298.042,837.871c-16.471,-36.863 -43.921,-47.842 -44.704,-16.471c-0.783,31.371 -3.921,48.629 -3.921,48.629c0,0 -22.746,-70.588 -74.508,-135.688c-51.767,-65.096 -164.704,-149.021 -233.725,-181.175c-69.021,-32.158 -128.625,-36.079 -129.413,-29.804c-0.783,6.275 20.392,23.529 20.392,23.529c0,0 -101.175,-16.471 -105.883,-6.275c-4.704,10.196 31.375,25.096 31.375,25.096c0,0 -105.1,10.196 -146.667,15.688c-19.071,2.521 -36.813,-4.45 -51.579,-15.283c-25.554,-25.854 -5.875,-68.837 -14.108,-76.483c-7.021,-6.517 -24.321,3.387 -30.35,28.613c-36.517,6.163 -185.533,145.504 -185.533,145.504c25.713,31.892 59.221,57.708 104.704,74.2c-85.438,26.133 -142.279,75.262 -144.704,168.154c-72.942,36.079 -84.008,344.312 0,497.646c0,0 -41.763,10.588 -30,78.825c11.767,68.233 31.175,122.942 57.646,174.704c26.471,51.762 73.529,41.767 73.529,41.767c0,0 19.413,17.646 47.646,11.175c28.233,-6.471 34.704,-21.175 34.704,-21.175c0,0 35.883,6.471 35.883,-19.412c0,-25.883 -11.767,-35.883 -44.704,-77.058c-32.942,-41.175 -39.413,-55.296 -39.413,-55.296c12.521,1.096 22.521,-2.496 28.825,-12.942c0,0 -10,15.883 24.704,8.237c34.704,-7.646 75.296,-55.296 75.296,-55.296c23.654,33.342 54.904,61.65 101.175,80c0,0 -55.492,-4.9 -33.529,19.412c21.963,24.312 130.979,56.471 200.783,60.392c0,0 -39.621,25.125 12.55,32.158c110.587,14.9 196.079,-23.529 196.079,-23.529l110.588,-167.842c194.254,59.042 169.675,-260.225 191.763,-498.821l0,-21.175c-17.646,-32.942 -18.429,-83.137 -34.9,-120.004Z",
    style: {
      fill: "#f3d077",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.946,670.538c42.354,43.808 95.292,66.633 130.588,57.575",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#f3d077",
      strokeWidth: "8.33px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1061.154,1599.325c-34.375,-23.138 -84.379,-54.058 -110.567,-57.321c-42.354,-5.279 -61.846,-40.604 -61.846,-40.604c0,0 -59.333,2.354 -115.804,-5.704c-56.471,-8.058 -5.883,-38.321 -5.883,-38.321c0,0 -68.233,-11.267 -87.058,-23.033c-18.825,-11.763 31.767,-21.763 31.767,-21.763c0,0 -92.942,-33.529 -121.175,-101.913l-61.938,167.204l5.654,19.25c11.538,-10.817 19.221,-19.838 19.221,-19.838c23.654,33.342 54.904,61.65 101.175,80c0,0 -55.492,-4.9 -33.529,19.413c21.963,24.312 130.979,56.471 200.783,60.392c0,0 -39.621,25.125 12.55,32.158c110.587,14.904 196.079,-23.529 196.079,-23.529l30.571,-46.392Z",
    style: {
      fill: "#f3d077",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.708,1457.375c43.529,15.792 97.004,0 97.004,0",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#f3d077",
      strokeWidth: "8.33px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1193.783,1455.467c43.083,32.604 80.217,-6.567 114.725,28.729c34.508,35.296 70.317,70.542 184.042,144.267c113.725,73.725 192.942,99.608 197.646,130.196c4.704,30.588 -23.529,34.508 -23.529,34.508c0,0 7.842,31.371 -21.175,41.567c-29.021,10.196 -47.058,0 -47.058,0c0,0 -7.058,41.571 -51.763,39.217c-44.704,-2.354 -39.217,-50.196 -39.217,-50.196c0,0 -111.371,7.058 -200,-6.275c-88.625,-13.333 -23.529,-35.296 -23.529,-35.296c0,0 -77.646,-16.471 -145.096,-42.354c-67.45,-25.883 -80,-50.196 -72.942,-54.117c7.058,-3.921 25.883,-0.783 25.883,-0.783c0,0 -67.45,-32.158 -110.587,-74.508c-43.138,-42.354 -64.313,-68.417 -64.313,-68.417c0,0 -36.079,32.338 -70.587,-22.567c-34.508,-54.904 -50.196,-141.175 -44.704,-196.863c5.492,-55.688 280,101.963 280,101.963l112.204,30.929Z",
    style: {
      fill: "#f3d077",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1551.767,1859.046l0,27.058",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#933642",
      strokeWidth: "8.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1659.183,1826.108l0,17.646",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#933642",
      strokeWidth: "8.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1684.033,1783.904l0,22.879",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#933642",
      strokeWidth: "8.33px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1690.196,1758.654c-3.863,-25.112 -57.975,-47.075 -140.15,-94.929c-86.321,-11.838 -52.004,42.379 -52.004,42.379c0,0 -36.079,-32.358 -42.354,-22.063c-6.275,10.296 35.296,39.317 35.296,39.317c0,0 -62.746,-33.725 -103.529,-27.45c-40.783,6.275 -39.217,52.55 -39.217,52.55c0,0 -31.533,-36.079 -73.021,-30.588c-29.5,3.904 -34.846,35.633 -35.475,53.646c26.175,6.842 44.183,10.667 44.183,10.667c0,0 -65.096,21.963 23.529,35.296c88.629,13.333 200,6.275 200,6.275c0,0 -5.492,47.842 39.217,50.196c44.704,2.354 51.763,-39.217 51.763,-39.217c0,0 18.037,10.196 47.058,0c29.021,-10.196 21.175,-41.567 21.175,-41.567c0,0 28.238,-3.925 23.529,-34.512Z",
    style: {
      fill: "#e5952a",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1353.217,1692.821c69.804,-20.392 137.767,30.537 137.767,30.537",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#e5952a",
      strokeWidth: "8.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.154,1731.254c47.058,-43.138 93.575,-18.921 122.079,17.208",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#e5952a",
      strokeWidth: "8.33px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1598.433,1834.733c10.979,-50.196 -32.942,-62.746 -32.942,-62.746",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#f3d077",
      strokeWidth: "8.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1666.667,1793.167c-2.354,-44.704 -52.55,-44.704 -52.55,-44.704",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#f3d077",
      strokeWidth: "8.33px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1332.546,957.062c-13.488,-25.775 -17.021,-61.75 -25.725,-93.721c-24.9,24.425 -49.763,69.267 -49.763,69.267c0,0 -82.942,-70.417 -94.704,-57.871c-11.767,12.546 9.412,57.871 9.412,57.871c0,0 -153.392,-17.871 -173.167,-12.775c-19.775,5.096 39.621,35.683 39.621,35.683c0,0 -231.158,-22.913 -216.258,54.783c8.979,46.821 87.417,104.538 87.417,104.538c0,0 -117.8,21.854 -108.883,64.204c8.917,42.354 129.596,81.896 129.596,81.896c0,0 -26.825,71.237 25.162,97.242c51.988,26.004 76.512,25.567 76.512,25.567c0,0 9.75,94.562 85.883,83.137c76.133,-11.425 157.567,-70.796 157.567,-70.796l57.329,-439.025Z",
    style: {
      fill: "#f3d077",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1201.008,771.046c-7.708,-12.092 -16.396,-24.496 -26.104,-36.704c-51.767,-65.096 -164.704,-149.021 -233.725,-181.175c-69.021,-32.158 -128.625,-36.079 -129.413,-29.804c-0.783,6.275 20.392,23.529 20.392,23.529c0,0 -101.175,-16.471 -105.883,-6.275c-4.704,10.196 31.375,25.096 31.375,25.096c0,0 -152.942,26.275 -155.296,79.217c-2.354,52.942 102.354,64.704 102.354,64.704c0,0 -51.763,3.529 -40,29.413c11.767,25.883 117.004,52.942 117.004,52.942c0,0 -58.183,25.883 46.521,51.762c104.704,25.883 198.471,31.767 185.704,0c0,0 31.942,7.058 34.296,-16.471c2.354,-23.529 -11.767,-57.646 -11.767,-57.646c0,0 178.133,111.079 164.542,1.413Z",
    style: {
      fill: "#e5952a",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M781.717,820.617c103.779,78.433 219.854,61.175 215.933,36.079",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#e5952a",
      strokeWidth: "8.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.946,734.342c17.254,70.587 127.071,57.254 127.071,57.254",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#e5952a",
      strokeWidth: "8.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1058.042,833.167c4.704,-19.608 -4.704,-53.333 -37.646,-75.292",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#e5952a",
      strokeWidth: "8.33px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M1156.45,713.058c-56.821,-61.05 -153.575,-131.146 -215.271,-159.892c-69.021,-32.158 -128.625,-36.079 -129.413,-29.804c-0.783,6.275 20.392,23.529 20.392,23.529c0,0 -101.175,-16.471 -105.883,-6.275c-4.704,10.196 31.375,25.096 31.375,25.096c0,0 -105.1,10.196 -146.667,15.688c-41.567,5.492 -101.175,67.45 -21.175,83.137c80,15.688 90.979,-14.117 90.979,-14.117c0,0 -6.275,-21.962 25.096,-12.55c31.371,9.412 59.138,31.229 59.138,31.229c0,0 -7.267,-45.346 14.642,-39.071c21.908,6.275 87.4,39.071 87.4,39.071c0,0 -15.296,-50.05 11.371,-28.092c26.667,21.958 144.508,95.688 171.863,86.275c27.354,-9.413 15.983,-69.021 15.983,-69.021c0,0 45.475,61.7 90.171,54.796Z",
    style: {
      fill: "#f3d077",
      fillOpacity: 0.7,
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1563.138,973.558c84.704,-64.312 93.333,-114.508 55.688,-118.433c-37.646,-3.921 -272.942,46.275 -272.942,122.354c-0,76.079 217.254,-3.921 217.254,-3.921Z",
    style: {
      fill: "#e5952a",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1564.658,940.079c-34.308,-10.242 -60.196,-32.183 -72.45,-61.396c-71.854,21.388 -146.325,55.996 -146.325,98.8c0,76.079 217.254,-3.921 217.254,-3.921c12.688,-9.633 23.633,-18.938 33.004,-27.829c-10.438,-0.721 -20.954,-2.512 -31.483,-5.654Z",
    style: {
      fill: "#e5952a",
      fillOpacity: 0.57,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1624.312,875.521c-43.138,-7.842 -153.2,44.85 -180.392,89.413",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#933642",
      strokeWidth: "8.33px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1308.508,1484.196c101.7,90.233 186.667,13.333 210.317,-20.442c60.117,-10.546 114.45,-38.475 138.821,-156.471c28.575,1.117 44.658,-24.708 40,-95.296c46.667,-112.942 -12.942,-186.667 -121.804,-227.058c0,0 49.454,-16.471 -25.842,-32.354c-75.296,-15.883 -127.058,3.529 -127.058,3.529c0,0 -40.587,-18.825 -132.942,-3.529c-92.354,15.296 -78.233,34.117 -140.588,25.883c-62.354,-8.238 -181.767,-23.529 -243.529,0.587c-61.763,24.117 -33.529,72.354 18.238,108.233c51.762,35.883 98.233,49.412 98.233,49.412c0,0 -37.254,38.433 -41.175,101.963c-3.921,63.529 40.783,66.667 40.783,66.667c0,0 -2.354,63.529 52.55,100.392c54.9,36.862 90.979,31.371 90.979,31.371c18.246,25.904 60.663,54.588 143.017,47.113Z",
    style: {
      fill: "#f3d077",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1592.471,1412.579c78.117,-8.825 66.35,-120.588 64,-128.825",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#f3d077",
      strokeWidth: "8.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1718.825,1073.279c-45.883,-69.525 -143.488,-71.875 -143.488,-71.875",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#f3d077",
      strokeWidth: "8.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M969.413,1286.017c-25.883,-61.083 32.508,-131.675 70.371,-142.263",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#f3d077",
      strokeWidth: "8.33px"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1575.842,984.933c6.179,-2.504 11.246,-6.138 15.413,-10.479c2.65,-6.071 -4.129,-14.042 -41.254,-21.875c-75.296,-15.883 -127.058,3.529 -127.058,3.529c0,0 -40.587,-18.825 -132.942,-3.529c-60.037,9.942 -75.083,21.371 -95.392,25.892c-88.358,45.558 -31.079,101.754 27.746,102.933c58.825,1.175 129.413,-22.354 129.413,-22.354c0,0 -17.646,33.887 27.058,29.296c44.704,-4.592 80,-39.883 80,-39.883c0,0 10.588,25.883 55.292,-2.354c44.704,-28.237 -10.588,-47.058 -10.588,-47.058c0,0 31.683,2.354 72.312,-14.117Z",
    style: {
      fill: "#e5952a",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1167.063,1050.812c11.767,61.175 145.513,51.767 203.346,0",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#e5952a",
      strokeWidth: "8.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1424.708,1084.783c40,-19.85 38,-67.229 38,-67.229",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#e5952a",
      strokeWidth: "8.33px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M895.121,1014c-13.212,6.85 -1.062,48.171 29,73.288c48.337,40.379 98.233,49.412 98.233,49.412c0,0 32.55,-36.862 61.571,-54.9c29.017,-18.046 -146.45,-89.763 -188.804,-67.8Z",
    style: {
      fill: "#f3d077",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1628.237,1094.342c-81.567,-32.942 -128.625,29.804 -128.625,29.804",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#4e1d23",
      strokeWidth: "8.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1410.196,1139.992c-81.567,-32.942 -128.629,29.804 -128.629,29.804",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#4e1d23",
      strokeWidth: "8.33px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1514.679,1147.767c1.021,6.196 -18.596,14.588 -43.812,18.742c-25.217,4.154 -46.487,2.496 -47.508,-3.7c-1.021,-6.196 18.596,-14.587 43.812,-18.742c25.221,-4.154 46.487,-2.496 47.508,3.7Z",
    style: {
      fill: "#933642",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1332.942,1205.717c85.883,100.392 147.058,12.55 143.921,-28.233c0,0 15.517,58.246 71.371,41.567c57.133,-17.058 43.529,-82.354 43.529,-82.354",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#e17f1d",
      strokeWidth: "8.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1431.767,1276.587c57.646,49.413 100.588,1.763 102.354,-31.767",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#e17f1d",
      strokeWidth: "8.33px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1650,1169.796c182.354,50.429 259.412,118.721 259.412,118.721",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#e5952a",
      strokeWidth: "8.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1656.471,1146.108c149.412,-9.413 282.35,42.354 282.35,42.354",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#e5952a",
      strokeWidth: "8.33px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1233.529,1201.992c-151.175,32.354 -315.163,137.021 -366.471,191.763",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#e5952a",
      strokeWidth: "8.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M938.238,1469.05c75.704,-93.529 105.883,-154.013 318.821,-244.704",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#e5952a",
      strokeWidth: "8.33px"
    }
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M434.121,737.954c-85.438,26.133 -142.279,75.262 -144.704,168.154c-53.346,26.383 -73.583,198.329 -47.754,348.796c22.454,-15.383 40.696,-67.621 40.696,-67.621c0,0 15.296,83.529 52.942,75.292c37.646,-8.233 45.883,-190.588 45.883,-190.588c235.292,-88.233 231.762,-338.821 52.938,-334.033Z",
    style: {
      fill: "#e5952a",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M245.496,1193.167c-65.883,-137.254 -3.137,-313.725 58.038,-286.275",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#e5952a",
      strokeWidth: "8.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.75,1244.167c29.804,25.075 66.667,-127.867 33.725,-186.688",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#e5952a",
      strokeWidth: "8.33px"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M607.062,1143.754c0,0 -233.133,195.787 -342.75,202.013c7.163,20.921 15.504,40.475 25.1,57.987c0,0 -41.762,10.587 -30,78.825c11.767,68.233 31.175,122.942 57.646,174.704c26.471,51.763 73.529,41.767 73.529,41.767c0,0 19.413,17.646 47.646,11.175c28.233,-6.471 34.704,-21.175 34.704,-21.175c0,0 35.883,6.471 35.883,-19.412c0,-25.883 -11.767,-35.883 -44.704,-77.058c-32.942,-41.175 -39.413,-55.296 -39.413,-55.296c12.854,0.267 23.304,-2.85 28.825,-12.942c0,0 -10,15.883 24.704,8.237c34.704,-7.646 75.296,-55.296 75.296,-55.296c37.842,-47.254 52.746,-120.196 57.45,-180.588c4.708,-60.392 -3.917,-152.942 -3.917,-152.942Z",
    style: {
      fill: "#f3d077",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.071,1599.971c-1.904,-2.35 -3.883,-4.808 -5.95,-7.392c-32.942,-41.175 -39.413,-55.296 -39.413,-55.296c7.629,0.158 14.379,-0.925 19.788,-3.9l-9.638,-9.629l-74.071,-20.783c-67.45,-35.296 -50.196,68.183 18.825,89.387c35.888,11.021 67.938,10.575 90.458,7.613Z",
    style: {
      fill: "#f3d077",
      fillOpacity: 0.4,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M472.946,1689.046c19.608,-37.842 -18.825,-59.804 -18.825,-59.804",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#e5952a",
      strokeWidth: "8.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.592,1699.05c31.371,-33.725 1.567,-63.529 4.704,-62.746",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#e5952a",
      strokeWidth: "8.33px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M553.533,1477.283c37.842,-47.254 52.746,-120.196 57.45,-180.588c0.217,-2.779 0.396,-5.642 0.558,-8.546c-12.092,-49.1 -50.904,-47.6 -81.342,30.504c0,0 -1.567,-48.629 -27.45,-23.529c-25.883,25.1 -32.942,137.254 -32.942,137.254c0,0 -17.254,-27.45 -20.392,-10.979c-3.137,16.471 8.629,38.433 8.629,38.433c0,0 -22.058,3.921 -23.188,20.392c-1.129,16.471 5.146,22.746 5.146,22.746c0,0 -72.158,-10.196 -79.217,0c-6.433,9.292 37.863,27.05 66.288,34.279c11.754,-0.162 21.287,-3.454 26.458,-12.908c0,0 -10,15.883 24.704,8.237c34.708,-7.65 75.296,-55.296 75.296,-55.296Z",
    style: {
      fill: "#e5952a",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M511.375,1297.871c-50.196,1.962 -47.312,121.175 -41.304,150.196",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#e5952a",
      strokeWidth: "8.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.592,1508.067c-45.883,-15.296 -23.392,-52.942 19.479,-50.588",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#e5952a",
      strokeWidth: "8.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.825,1243.167c-37.646,-11.762 -72.942,55.883 -70,87.058",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#e5952a",
      strokeWidth: "8.33px"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M345.688,681.992c-33.529,-28.433 -32.742,-51.179 -32.742,-51.179c0,0 -59.033,-52.942 -82.458,-167.058c-23.425,-114.117 30.692,-187.058 45.988,-187.058c15.296,0 22.354,20 22.354,20c0,0 27.058,-76.471 90.588,-116.471c63.529,-40 141.175,-47.058 140,-34.117c-1.175,12.942 -15.296,24.704 -15.296,24.704c0,0 83.529,-28.233 211.762,-2.354c128.233,25.883 176.471,81.175 175.292,89.413c-1.175,8.233 -31.767,7.058 -31.767,7.058c0,0 21.175,31.767 84.704,63.529c63.529,31.762 27.058,48.233 27.058,48.233c0,0 68.233,11.767 149.412,-1.175c81.175,-12.942 188.233,-2.354 202.354,95.292c14.117,97.646 -64.704,142.354 -64.704,142.354c0,0 1.175,31.767 -52.942,45.883c-54.117,14.117 -151.688,-28.333 -151.688,-28.333c0,0 -43.604,28.333 -108.308,-1.079c-64.704,-29.412 -91.763,-82.354 -149.413,-148.233c-57.646,-65.879 -141.175,-110.583 -221.175,-88.233c-80,22.354 -62.354,127.683 -62.354,127.683l-96.471,120.55l-80.196,40.592Z",
    style: {
      fill: "#f3d077",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M889.283,460.033c-53.204,-74.708 -107.567,-76.279 -107.567,-76.279c0,0 80.229,-75.296 17.883,-111.371c-62.342,-36.079 -81.167,34.508 -81.167,34.508c0,0 -53.333,-29.804 -80,1.567c-18.625,21.908 -5.883,59.1 3.5,79.554c56.442,4.883 111.158,37.679 153.837,82.346c74.387,31.408 130.954,42.254 93.512,-10.325Z",
    style: {
      fill: "#e5952a",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M482.946,133.758c-86.471,14.704 -120,81.175 -120,81.175",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#e5952a",
      strokeWidth: "8.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.317,279.442c-27.413,-30.588 -119.371,25.883 -119.371,25.883",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#e5952a",
      strokeWidth: "8.33px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M800.017,287.842c98.808,41.796 19.592,108.463 -28.25,98.267",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#e5952a",
      strokeWidth: "8.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.65,482.579c-2.354,-80.783 -163.137,-103.175 -163.137,-103.175",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#e5952a",
      strokeWidth: "8.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.179,387.154c75.292,16.013 106.471,74.837 106.471,74.837",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#e5952a",
      strokeWidth: "8.33px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M520.779,501.604c-0.792,-29.592 4.796,-84.929 54.1,-105.013c5.483,-24.237 -14.175,-29.117 -55.663,-17.188c0,0 95.688,-36.433 75.296,-77.217c-20.392,-40.783 -105.1,-3.137 -105.1,-3.137c0,0 150.588,-145.883 24.704,-128.233c0,0 14.117,-11.767 15.296,-24.704c1.175,-12.942 -76.471,-5.883 -140,34.117c-9.592,6.037 -18.337,12.917 -26.3,20.229c-0.504,0.746 -46.129,68.246 -24.292,111.925c21.963,43.921 114.508,14.117 114.508,14.117c0,0 -98.817,85.492 -63.521,151.375c20.712,38.667 83.017,34.096 130.971,23.729Z",
    style: {
      fill: "#e5952a",
      fillRule: "nonzero"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1282.354,411.1c-74.117,-79.108 -156.862,-50.875 -261.958,-16.758",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#f3d077",
      strokeWidth: "8.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.079,250.817c70.979,61.175 161.667,81.175 161.667,81.175",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#f3d077",
      strokeWidth: "8.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.713,233.167c17.525,-65.883 -171.883,-90.588 -248.354,-69.412",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#f3d077",
      strokeWidth: "8.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.121,337.5c-81.175,108.608 -31.767,237.292 87.058,310.008",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#f3d077",
      strokeWidth: "8.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.179,202.579c-37.646,44.708 -51.762,84.708 -43.529,112.942",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#f3d077",
      strokeWidth: "8.33px"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1268.238,613.167c-18.158,55.95 -104.042,62.204 -204.629,17.55c-92.646,32.304 -158.821,-17.108 -224.008,-108.6c0,0 -41.829,-54.917 -85.083,-91.125",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#933642",
      strokeWidth: "8.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1584.767,963.717c-77.075,-34.596 -161.825,-7.608 -161.825,-7.608c-120.075,-25.342 -194.433,15.933 -228.333,22.362c-33.9,6.433 -122.875,-19.508 -227.288,-11.321c-82.342,6.458 -124.771,37.108 -80.812,86.492c43.958,49.383 89.692,74.379 135.846,83.058",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#933642",
      strokeWidth: "8.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1125.492,1015.129c-55.688,30.587 -231.192,-15.271 -235.675,4.658c-4.483,19.929 8.617,46.617 34.304,67.5",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#933642",
      strokeWidth: "8.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1102.233,1072.025c-56.471,29.425 -85.304,73.646 -99.946,93.567",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#933642",
      strokeWidth: "8.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074.513,1405.717c38.704,35.342 90.979,31.371 90.979,31.371c0,0 18.312,31.963 68.038,44.2c32.871,8.092 74.979,2.908 74.979,2.908c0,0 36.879,42.146 88.629,42.354c34.629,0.138 81.025,-2.45 121.688,-62.792",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#933642",
      strokeWidth: "8.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1332.546,1504.692c70.704,82.85 217.5,159.033 314.533,213.592c0,0 38.7,19.221 43.117,40.371c5.762,27.6 -23.529,34.508 -23.529,34.508",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#933642",
      strokeWidth: "8.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M916.867,1542.004c70.858,85.721 129.529,120.133 174.9,142.925c0,0 -49.583,-6.746 -22.637,14.117c26.946,20.862 49.817,45.833 214.792,83.137",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#933642",
      strokeWidth: "8.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.021,721.842c-111.763,16.471 -208.388,56.767 -213.604,184.267",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#933642",
      strokeWidth: "8.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.354,1057.479c0,0 36.079,148.283 17.254,178.954c-18.825,30.671 -36.471,-21.55 -36.471,-21.55c0,0 -8.238,161.312 -44.562,233.183c-37.292,73.775 -122.65,111.129 -119.042,76.275c0,0 -19.925,43.629 -117.571,-32.671",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#933642",
      strokeWidth: "8.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.154,1476.513c10.1,23.529 72.254,70.587 105.121,77.208c0,0 -46.729,3.229 -43.183,12.804c3.183,8.608 40.388,39.083 103.992,50.021",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#933642",
      strokeWidth: "8.33px"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCat2);
export default __webpack_public_path__ + "static/media/cat2.a5551920e84f3d089bf72b6decea2e8a.svg";
export { ForwardRef as ReactComponent };